<template>
  <table v-if="products.length > 0" id="cart" class="table table-hover table-condensed">
    <thead>
      <tr>
        <th style="width:50%"></th>
        <th style="width:10%"></th>
        <th style="width:8%" ></th>
        <th style="width:22%"></th>
        <th style="width:10%"></th>
      </tr>
    </thead>
    <tbody v-for="product in products" track-by="$index">
      <tr>
        <td data-th="">
          <div class="row">
            <a v-link="{ name: 'Product', params: { id: product.ProductId, pname: $options.filters.slugurl(product.Name) }}">
            <div class="col-sm-2"><img v-lazy="product.Photos[0].URL" class="img-responsive"/></div>
            <div class="col-sm-10">
              <h4 class="nomargin">{{product.Name}}</h4>
            </div>
            </a>
            <div class="col-sm-6 visible-xs">
              {{(product.Price * product.Quantity) | currencyDisplay}}
              <button class="btn btn-danger btn-sm" @click="remove($index)"><i class="fa fa-trash-o"></i> Verwijder</button>
            </div>
          </div>
        </td>
        <td colspan="1" class="">
          <input type="number" class="form-control" name="quantity" value="1" min="1" max="10" v-if="product.MenuItemId===46" v-model="product.Quantity">
        </td>
        <td colspan="2" class="hidden-xs text-right">
          <h4 style="padding-top:0px;"><strong>{{(product.Price * product.Quantity) | currencyDisplay}}</strong></h4>
        </td>
        <td colspan="2" class="actions hidden-xs text-right" data-th="">
          <button class="btn btn-danger" @click="remove($index)"><i class="fa fa-trash-o"></i> Verwijder</button>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr class="visible-xs">
        <td class="text-center">
          <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p>
          <p>
            <strong>Verzendkosten {{shippingCost | currencyDisplay}}</strong>
            <div class="v-tooltip">?
              <span class="v-tooltiptext">De verzendkosten worden na verwerking van je order opnieuw berekend.</span>
            </div>
          </p>
          <h3><strong>Totaal {{totalPrice | currencyDisplay}}</strong></h3>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="hidden-xs"></td>
        <td colspan="2" class="hidden-xs text-right">
        <p><strong>subtotaal {{subtotal | currencyDisplay}}</strong></p>
        <p>
          <strong>Verzendkosten {{shippingCost | currencyDisplay}}</strong>
          <div class="v-tooltip">?
            <span class="v-tooltiptext">De verzendkosten worden na verwerking van je order opnieuw berekend.</span>
          </div>
        </p>
        <h3><strong>Totaal {{totalPrice | currencyDisplay}}</strong></h3>
        </td>
      </tr>
    </tfoot>
  </table>
  <div class="card-content no-padding" v-if="products.length < 1">
    <h2>Geen Producten gevonden</h2>
  </div>
</template>
<script>
import store from '../../store'
import ac from 'accounting'
import shippingRatesData from '../../assets/shippingRates.json'

export default {
  props: {
  },
  route: {
    canReuse: false
  },
  components: {
  },
  data () {
    return {
      store: store,
      shippingCost: shippingRatesData.shipping_rates[0].price
    }
  },
  created () {
  },
  methods: {
    remove: function (index) {
      this.products.splice(index, 1)
      sessionStorage.setItem('winkelwagen', JSON.stringify(this.products))
    }
  },
  computed: {
    products: function () {
      return this.store.cart
    },
    subtotal: function () {
      var total = 0
      for (var i = 0; i < this.products.length; ++i) {
        if (this.products[i].Quantity < 1) {
          this.products[i].Quantity = 1
        }
        total += parseFloat(ac.unformat(this.products[i].Price, ',')) * this.products[i].Quantity
      }
      return total
    },
    totalPrice: function () {
      return ((this.subtotal || 0) + (this.shippingCost || 0))
    }
  }
}
</script>
<style scoped>
 .table>tbody>tr>td, .table>tfoot>tr>td{
    vertical-align: middle;
}
@media screen and (max-width: 768px) {
    table#cart tbody td .form-control{
    width:20%;
    display: inline !important;
  }
  .actions .btn{
    width:36%;
    margin:1.5em 0;
  }
  
  .actions .btn-info{
    float:left;
  }
  .actions .btn-danger{
    float:right;
  }
  
  table#cart thead { display: none; }
  table#cart tbody tr td:first-child { background: #333; color: #fff; }
  table#cart tbody td:before {
    content: attr(data-th); font-weight: bold;
    display: inline-block; width: 8rem;
  }
  
  
  
  table#cart tfoot td{display:block; }
  table#cart tfoot td .btn{display:block;}
  
}

.v-tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
    cursor: pointer;
}

.v-tooltip .v-tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    right: -20px;

    /* Position the v-tooltip */
    position: absolute;
    z-index: 9999999999999;
}

.v-tooltip:hover .v-tooltiptext {
    visibility: visible;
}

</style>


// WEBPACK FOOTER //
// cart.vue?5262ec4c